export class GenericResponseDto {
  detail: string
  status_code: number
  summary: string
  type: string
}